export default "__VITE_ASSET__Ccqmqj$2__"